export const DEMO_LABELS = {
  gender: {
    1: "Female",
    2: "Male",
  },
  age: {
    1: "Young",
    2: "Middle",
    3: "Old",
  },
  education: {
    1: "High",
    2: "Mid",
    3: "Low",
  },
  ethnicity: {
    1: "European only",
    2: "Māori only",
    3: "Pacific Peoples only",
    4: "Asian only",
    5: "Other",
  },
  party: {
    1: "NAT",
    2: "LAB",
    3: "ACT",
    4: "GREEN",
    5: "NZF",
    6: "TPM",
    7: "OTH",
    8: "DNV",
  },
};

// Sidebar filter chip options: [value, label] pairs in display order
export const DEMO_FILTER_OPTIONS = {
  gender:    [[2, "Male"], [1, "Female"]],
  age:       [[1, "Young"], [2, "Middle"], [3, "Old"]],
  education: [[1, "High"], [2, "Mid"], [3, "Low"]],
  ethnicity: [
    [1, "European only"], [2, "Māori only"], [3, "Pacific Peoples only"], [4, "Asian only"], [5, "Other"],
  ],
  party: [
    [1, "National"], [2, "Labour"], [3, "ACT"],
    [4, "Green"], [5, "NZ First"], [6, "Te Pāti Māori"],
    [7, "Other"], [8, "Did Not Vote"],
  ],
};
